import React, { Component } from 'react';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';


class TextEditor extends Component {
    render() {
        return (
            <div className="App malayalam">
                <CKEditor
                    editor={ClassicEditor}
                    data={this.props.editorResetDate}
                    config={{
                        toolbar: ['heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList',  'htmlEmbed'],

                    }}
                    onReady={editor => {
                        // You can store the "editor" and use when it is needed.
                    }}
                    onChange={(event, editor) => {
                        const data = editor.getData();
                        this.props.editorData(data)
                    }}
                    onBlur={(event, editor) => {
                        // console.log('Blur.', editor);
                    }}
                    onFocus={(event, editor) => {
                        // console.log('Focus.', editor);
                    }}
                />

            </div>
        );
    }
}

export default TextEditor;




